import React, { createContext, useState, useEffect, useContext } from 'react';

const API_BASE = process.env.REACT_APP_API_URL;


export const DataContext = createContext({
  projects: [],
  skills: [],
  loading: false,
});

/**
 * DataProvider — contexto global opcional.
 * Ya no bloquea el render del App con una pantalla de loading.
 * Los componentes que necesiten datos deben manejar su propio estado.
 */
export const DataProvider = ({ children }) => {
  const [projects, setProjects] = useState([]);
  const [skills,   setSkills]   = useState([]);
  const [loading,  setLoading]  = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async () => {
      setLoading(true);
      try {
        const [projectsRes, skillsRes] = await Promise.allSettled([
          fetch(`${API_BASE}/projects`, { signal: controller.signal }),
          fetch(`${API_BASE}/skills`,   { signal: controller.signal }),
        ]);

        if (projectsRes.status === 'fulfilled' && projectsRes.value.ok) {
          setProjects(await projectsRes.value.json());
        }
        if (skillsRes.status === 'fulfilled' && skillsRes.value.ok) {
          setSkills(await skillsRes.value.json());
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          // Fallido silencioso para producción
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    return () => controller.abort();
  }, []);

  const value = React.useMemo(() => ({ projects, skills, loading }), [projects, skills, loading]);

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
};

/** Hook de conveniencia */
export const useData = () => useContext(DataContext);
